<template>
    <div class="page-body date-range-selector">
        <NoButtonModal :open="true">
            <div class="modal-content-header">
                <span style="font-size: 20px; font-weight: bold; margin-left: 20px"> Select Custom Date Range </span>
            </div>
            <div class="d-flex flex-column gap-3" style="padding: 2rem">
                <span style="font-size: 1.2rem"> Please select a date range to view custom period data </span>
                <ejs-daterangepicker
                    :startDate="start"
                    :endDate="end"
                    :max="maxDate"
                    format="MMM dd yyyy"
                    :placeholder="'Start date ~ End date'"
                    :width="'100%'"
                    @change="onChange"
                />
            </div>
            <div class="mx-4 d-flex justify-content-end">
                <button type="button" class="no-bg btn-cancel px-4" @click="$emit('cancel')">Cancel</button>
                <button type="button" class="primary btn-save" @click="save">Apply</button>
            </div>
        </NoButtonModal>
    </div>
</template>

<script>
    import NoButtonModal from '@/components/general/modals/NoButtonModal';
    import { DateRangePickerComponent } from '@syncfusion/ej2-vue-calendars';
    import moment from 'moment';

    export default {
        name: 'DateRangeSelectorModal',
        components: {
            NoButtonModal,
            'ejs-daterangepicker': DateRangePickerComponent,
        },
        props: {
            startDate: {
                type: String,
                default: null,
            },
            endDate: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                start: this.startDate ? new Date(this.startDate) : null,
                end: this.endDate ? new Date(this.endDate) : null,
                maxDate: new Date(),
            };
        },
        methods: {
            onChange(args) {
                if (args && args.startDate && args.endDate) {
                    this.start = args.startDate;
                    this.end = args.endDate;
                }
            },
            save() {
                if (!this.start || !this.end) {
                    this.$toasted.error('Please select a valid date range');
                    return;
                }
                this.$emit('save', {
                    startDate: this.start.getTime(),
                    endDate: this.end.getTime(),
                });
            },
        },
    };
</script>

<style scoped>
    .modal-content-header {
        background-color: #f1f7ff;
        padding: 10px;
        display: flex;
        align-items: center;
    }

    .btn-save {
        border-radius: 10px;
        background: #5155c3 !important;
        box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.03);
    }

    .btn-cancel,
    .btn-cancel:hover {
        border-radius: 10px;
        border: 2px solid #ac2734;
    }
</style>

<style>
    .date-range-selector .modal__content {
        padding: 0;
        border-radius: 10px;
        min-height: fit-content;
    }

    .date-range-selector .modal__content input:not([class='multiselect__input']) {
        box-shadow: none;
    }

    .date-range-selector .e-input,
    .date-range-selector .e-input:focus,
    .date-range-selector .modal__content input:not([class='multiselect__input']) {
        padding: 8px !important;
        border-radius: 5px !important;
    }
</style>
